<template>
    <div
        class="modal fade"
        :class="[props.className]"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        :aria-label="props.title"
        ref="modalElement">
        <div
            class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
            :style="`max-width: ${props.width}`">
            <div class="modal-content" style="overflow: visible;">
                <div class="modal-header">
                    <h4 class="modal-title">{{ props.title }}</h4>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>
                        <slot
                            name="body"
                            :on-dismiss="handleDismiss"
                            :on-submit="handleSubmit"
                            >{{ props.body }}</slot
                        >
                        <slot></slot>
                    </p>
                </div>
                <div
                    class="modal-footer"
                    v-if="props.showFooter">
                    <slot
                        name="footer"
                        :on-dismiss="handleDismiss"
                        :on-submit="handleSubmit"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import {onMounted, ref, watch} from "vue";
import {Modal} from "bootstrap";

const model = defineModel();
const props = withDefaults(
    defineProps<{
        showModal?: boolean;
        title?: string;
        body?: string;
        showFooter?: boolean;
        className?: string;
        width?: string;
    }>(),
    {
        showModal: false,
        title: "",
        width: "750px",
    }
);
let modalElement = ref<HTMLElement>();
let modelObject: Modal;

const state = ref(false);

onMounted(() => {
    modelObject = new Modal(modalElement.value);

    modalElement.value.addEventListener("hidden.bs.modal", (event) => {
        model.value = false;
        state.value = false;
        emit("dismiss");
    });
});

const emit = defineEmits<{
    (event: "dismiss"): void;
    (event: "submit"): void;
}>();

function handleDismiss() {
    emit("dismiss");
}

function handleSubmit() {
    emit("submit");
}

function _show() {
    state.value = true;
    modelObject.show();
}

function _hide() {
    state.value = false;
    modelObject.hide();
    model.value = false;
    emit("dismiss");
}

watch(
    () => props.showModal,
    (showModal, prevShowModal) => {
        state.value = showModal;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

watch(
    () => model.value,
    (showModal, prevShowModal) => {
        state.value = showModal as boolean;
        if (showModal) {
            _show();
        } else {
            _hide();
        }
    }
);

defineExpose({show: _show});
</script>
